// extracted by mini-css-extract-plugin
module.exports = {"captach":"src-components-common-province-validator-jiangshu-captcha-__index__captach--3VB6K"};